import { render, staticRenderFns } from "./addCostCenter.vue?vue&type=template&id=381d3710"
import script from "./addCostCenter.vue?vue&type=script&lang=js"
export * from "./addCostCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports